// noinspection JSUnresolvedVariable

/**
 * @param values
 * @author Aladdin Al-awadat (a.alawadat@elevatus.io)
 * @Description this method is to handle setups entire object (lazy)
 */
export const SetupsReset = (values) => ({
  ...values,
});

/**
 * @param state
 * @param action
 * @author Aladdin Al-awadat (a.alawadat@elevatus.io)
 * @Description this method is to handle setups states update using reduced
 */
export const GlobalReducer = (state, action) => {
  if (action.parentIndex || action.parentIndex === 0) {
    const localState = {...state};
    if (!localState[action.parentId][action.parentIndex] && action.id)
      localState[action.parentId][action.parentIndex] = {};
    if (!action.subParentId && !action.id) {
      localState[action.parentId][action.parentIndex] = action.value;

      return localState;
    }
    if (action.subParentId) {
      if (action.subParentIndex || action.subParentIndex === 0) {
        if (
          !localState[action.parentId][action.parentIndex][action.subParentId][
            action.subParentIndex
          ] &&
          action.id
        )
          localState[action.parentId][action.parentIndex] = {};
        if (!action.id) {
          localState[action.parentId][action.parentIndex][action.subParentId][
            action.subParentIndex
          ] = action.value;

          return localState;
        }

        localState[action.parentId][action.parentIndex][action.subParentId][
          action.subParentIndex
        ] = {
          ...localState[action.parentId][action.parentIndex][
            action.subParentId
          ][action.subParentIndex],
          [action.id]: action.value,
        };

        return localState;
      }
      if (!action.id) {
        localState[action.parentId][action.parentIndex][action.subParentId] =
          action.value;

        return localState;
      }
      localState[action.parentId][action.parentIndex][action.subParentId] = {
        ...localState[action.parentId][action.parentIndex][action.subParentId],
        [action.id]: action.value,
      };

      return localState;
    }
    localState[action.parentId][action.parentIndex] = {
      ...localState[action.parentId][action.parentIndex],
      [action.id]: action.value,
    };

    return localState;
  }
  if (action.subParentId)
    return {
      ...state,
      [action.parentId]: {
        ...(state[action.parentId] || {}),
        [action.subParentId]: {
          ...((state[action.parentId] &&
            state[action.parentId][action.subParentId]) ||
            {}),
          [action.id]: action.value,
        },
      },
    };
  if (action.parentId)
    return {
      ...state,
      [action.parentId]: {
        ...state[action.parentId],
        [action.id]: action.value,
      },
    };
  if (action.id === "reset") return SetupsReset(action.value);
  if (Array.isArray(action.id)) {
    const localState = {...state};
    action.id.map((item) => {
      localState[item] = action.value;

      return undefined;
    });

    return localState;
  }
  if (action.id === "destructObject") return {...state, ...action.value};
  if (action.id !== "edit") return {...state, [action.id]: action.value};

  return {...action.value};
};
